/*
 * @Author: zhangyang yang.zhang@corerain.com
 * @Date: 2023-02-28 16:54:27
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-10 11:34:41
 * @FilePath: \cr-croms-fe\src\hook\usePwdReset.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RuleObject } from 'ant-design-vue/lib/form/interface'
import { regPwd } from '@/utils/regExp'
export default function usePwdReset(modal: any) {
  // 自定义校验规则
  const checkPwd = async (rule: RuleObject, value: string) => {
    if (!value) {
      return Promise.reject('新密码不能为空')
    }

    if (value.length < 6 || value.length > 20) {
      return Promise.reject('新密码长度为6~20位')
    }

    if (value === formData[0].value) {
      return Promise.reject('新旧密码不能相同')
    }

    if (!regPwd.test(value)) {
      return Promise.reject('新密码不符合格式')
    }

    return Promise.resolve()
  }

  const checkConfirmPwd = async (rule: RuleObject, value: string) => {
    if (!value) {
      return Promise.reject('请输入确认密码')
    }

    if (value !== formData[1].value) {
      return Promise.reject('两次输入密码不同，请重新输入')
    }

    return Promise.resolve()
  }

  const getFormDataTemp = () => [
    {
      label: '原密码',
      type: 'password',
      value: '',
      placeholder: '请输入原密码',
      rules: [
        {
          required: true,
          message: '原密码不能为空',
          trigger: 'blur'
        }
      ],
      submitName: 'old_password'
    },
    {
      label: '新密码',
      type: 'password',
      value: '',
      placeholder: '请输入新密码',
      rules: [
        {
          required: true,
          validator: checkPwd,
          trigger: 'change'
        }
      ],
      submitName: 'new_password',
      bottomTip: '新密码为6~20位,字母、数字、特殊字符至少包含两种'
    },
    {
      label: '确认密码',
      type: 'password',
      value: '',
      placeholder: '请再次输入新密码',
      submitName: 'confirm_password',
      rules: [
        {
          required: true,
          validator: checkConfirmPwd,
          trigger: 'blur'
        }
      ]
    }
  ]

  const formData = getFormDataTemp()

  const showPwdResetModal = () => {
    modal.value.showModal(formData)
  }

  return {
    showPwdResetModal
  }
}
